/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type DetachOrganizationRemoteSessionClientKeySetSecurity = {
  sessionHeaderGramSession?: string | undefined;
  apikeyHeaderGramKey?: string | undefined;
};

export type DetachOrganizationRemoteSessionClientKeySetRequest = {
  /**
   * The remote_session_client id.
   */
  id: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
};

/** @internal */
export type DetachOrganizationRemoteSessionClientKeySetSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
  "apikey_header_Gram-Key"?: string | undefined;
};

/** @internal */
export const DetachOrganizationRemoteSessionClientKeySetSecurity$outboundSchema:
  z.ZodMiniType<
    DetachOrganizationRemoteSessionClientKeySetSecurity$Outbound,
    DetachOrganizationRemoteSessionClientKeySetSecurity
  > = z.pipe(
    z.object({
      sessionHeaderGramSession: z.optional(z.string()),
      apikeyHeaderGramKey: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        sessionHeaderGramSession: "session_header_Gram-Session",
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
      });
    }),
  );

export function detachOrganizationRemoteSessionClientKeySetSecurityToJSON(
  detachOrganizationRemoteSessionClientKeySetSecurity:
    DetachOrganizationRemoteSessionClientKeySetSecurity,
): string {
  return JSON.stringify(
    DetachOrganizationRemoteSessionClientKeySetSecurity$outboundSchema.parse(
      detachOrganizationRemoteSessionClientKeySetSecurity,
    ),
  );
}

/** @internal */
export type DetachOrganizationRemoteSessionClientKeySetRequest$Outbound = {
  id: string;
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
};

/** @internal */
export const DetachOrganizationRemoteSessionClientKeySetRequest$outboundSchema:
  z.ZodMiniType<
    DetachOrganizationRemoteSessionClientKeySetRequest$Outbound,
    DetachOrganizationRemoteSessionClientKeySetRequest
  > = z.pipe(
    z.object({
      id: z.string(),
      gramSession: z.optional(z.string()),
      gramKey: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        gramSession: "Gram-Session",
        gramKey: "Gram-Key",
      });
    }),
  );

export function detachOrganizationRemoteSessionClientKeySetRequestToJSON(
  detachOrganizationRemoteSessionClientKeySetRequest:
    DetachOrganizationRemoteSessionClientKeySetRequest,
): string {
  return JSON.stringify(
    DetachOrganizationRemoteSessionClientKeySetRequest$outboundSchema.parse(
      detachOrganizationRemoteSessionClientKeySetRequest,
    ),
  );
}
